type typeValues = 'string' | 'number' | 'short-date' | 'date' | 'currency' | 'percent';

export class TableStructureModel {
  columnKey: string;
  columnName: string;
  type: typeValues
  
  constructor(columnKey: string, columnName: string, type: typeValues) {
      this.columnKey = columnKey;
      this.columnName = columnName;
      this.type = type;
  }
}
  
export class TableMenuModel {
  icon: string;
  color: string;
  display: string;
  action: string;
  
  constructor(color: string, display: string, action: string, icon: string) {
      this.color = color;
      this.display = display;
      this.action = action;
      this.icon = icon;
  }
}

export class EventEmitedModel {
  action!: string;
  item: any;
}

export class HasPermissionModel {
  icon: string;
  color: string;
  display: string;
  action: string;
  
  constructor(color: string, display: string, action: string, icon: string) {
      this.color = color;
      this.display = display;
      this.action = action;
      this.icon = icon;
  }
}
